<template>
  <div>
    <memberinfo v-if="user_id != ''" class="member-container" :project_id="project_id"
                :user_id.sync="user_id"></memberinfo>
    <div class="workforce-container">
      <div class="workforce-container-left">
        <div class="workforce-container-left-one">
          <div class="workforce_item item_outer" @click="showDetail">
            <div class="item_outer_title">Main Con Total Workforce</div>
            <div class="item_outer_item">
              <div class="item_outer_item_count">{{ worker_count }}</div>
              <div class="item_outer_item_type">Workers</div>
            </div>
            <div class="item_outer_item">
              <div class="item_outer_item_count">{{ staff_count }}</div>
              <div class="item_outer_item_type">Staff</div>
            </div>
          </div>
          <div class="workforce_item">
            <stafforworker :project_id="project_id"></stafforworker>
          </div>
        </div>
        <div class="workforce-container-left-one">
          <div class="workforce_item">
            <nationality :project_id="project_id"></nationality>
          </div>
          <div class="workforce_item">
            <h1
              style="width: 100%; height: 30px; position: absolute; color: white; font-weight: bold; font-size: 16px; line-height: 30px; padding-left: 20px; text-align: left">
              {{ expired_title }}
              <div class="select expired"
                   style="z-index: 9;width: 13%;display: inline-block;font-size: 20px">
                <el-select v-model="default_tag"
                           placeholder="请选择" popper-class="optionsContent"
                           @change="switch_tag">
                  <el-option
                    v-for="item in multi_tags"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </h1>
            <div v-if="dataNotNull" key="1" class="expiredDiv"
                 style="width: 100%; height: 170px; margin-top: 40px">
              <div class="container1" style="height: 100%"></div>
            </div>
            <div v-else key="2"
                 style="width: 100%; height: 210px; line-height: 210px; color: #6CF; font-size: 24px;">
              No Data !
            </div>
          </div>
        </div>
      </div>
      <div class="workforce-container-left">
        <div class="has-border">
          <div class="member_title">Project Members</div>
          <div class="member_project" style="display: flex;flex-direction: column; text-align: left; width: 300px">
            <el-select v-model="default_company" placeholder="select contractor" popper-class="optionsContent"
                       @change="switch_company">
              <el-option
                v-for="(item, index) in multi_companies"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="member_container_item_expired">
            <div class="member_container_item_one_workforce item_big">S/N</div>
            <div class="member_container_item_two_workforce item_big">Name</div>
            <div class="member_container_item_two_workforce item_big">Designation</div>
          </div>
          <div class="member_container_item_container">
            <div style="width: 100%; margin-top: 18px; display: flex; align-items: center; text-align: center"
                 v-for="(item, index) in members[company_index]"
                 :key="'member_' + index">
              <div class="member_container_item_one_workforce_special">{{ index + 1 }}</div>
              <div class="member_container_item_two_workforce_special" @click="showMember(item)">{{
                  item.user_name.toUpperCase()
                }}
              </div>
              <div class="member_container_item_two_workforce_special">{{ item.role_type }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="workforce_detail" v-show="showflag" id="workforce_detail">
      <div class="close_img_workforce" @click="detailClose"></div>
      <div class="workforceDiv1"
           style="width: 100%; height: 100%; display: flex; flex-direction: column">
        <div class="workforce_detail_title">Workers</div>
        <div class="container1"></div>
        <div class="workforce_detail_title">Staff</div>
        <div class="container2"></div>
      </div>
    </div>

    <div class="member_detail" v-show="showflag2" id="member_detail">
      <div class="close_img_workforce" @click="detail2Close"></div>
      <div class="workforceDiv1"
           style="width: 100%; height: 100%; display: flex; flex-direction: column">
        <div
          style="height: 40px; font-size: 24px; font-weight: bold; width: 100%; text-align: center; line-height: 40px; color: #66CCFF; margin-top: 20px">
          {{ name.toUpperCase() }}
        </div>
        <div style="width: 100%; height: 150px; display: flex; justify-content: center">
          <img :src="avatar" style="width: 130px; height: 150px; object-fit: contain">
        </div>
        <div class="member_detail_item_small">Nationality: {{ nationality }}</div>
        <div class="member_detail_item_small">Designation: {{ designation }}</div>
        <div class="member_detail_item_small">Pass Type: {{ pass_type }}</div>
        <div class="member_detail_item_small member_margin_top">RA Role: {{ ra_role }}</div>
        <div class="member_detail_item_small">TBM Role: {{ tbm_role }}</div>
        <div class="member_detail_item_small">PTW Role: {{ ptw_role }}</div>
        <div class="member_detail_item_certs">
          <div class="member_detail_item_cert_title">Certs:</div>
          <div class="member_detail_item_cert" v-for="(item, index) in certs">{{ item }}</div>
        </div>
      </div>
    </div>

    <div class="work_expired_detail" v-show="showflag1" id="work_expired_detail">
      <div class="expiredDiv1"
           style="width: 100%; height: 100%; display: flex; flex-direction: column">
        <h1
          style="height: 30px; color: white; font-weight: bold; font-size: 16px; line-height: 30px; padding-left: 20px; text-align: center">
          <div class="select workforce h_big"
               style="z-index: 9;width: 80%;display: inline-block">
            <el-select v-model="default_tag"
                       placeholder="请选择" popper-class="optionsContent"
                       @change="switch_tag">
              <el-option
                v-for="item in multi_tags"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </h1>
        <div class="close_img_expired" @click="detail1Close"></div>
        <div class="workforce" style="width: 100%; height: 540px">
          <el-collapse accordion>
            <el-collapse-item title="Work Permit(WP)">
              <div class="expired_content_workforce">
                <div class="member_container_item_expired">
                  <div class="member_container_item_three item_big">S/N</div>
                  <div class="member_container_item_four item_big">Name</div>
                  <div class="member_container_item_four item_big">Employer</div>
                  <div class="member_container_item_four item_big">Expired</div>
                </div>
                <div class="member_container_item_expired" v-for="(item, index) in wps" :key="'wp_' + index">
                  <div class="member_container_item_three item_big">{{ index + 1 }}</div>
                  <div class="member_container_item_four item_big" style="text-align: left">{{ item.user_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.contractor_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.permit_enddate }}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="S Pass(SP)">
              <div class="expired_content_workforce">
                <div class="member_container_item_expired">
                  <div class="member_container_item_three item_big">S/N</div>
                  <div class="member_container_item_four item_big">Name</div>
                  <div class="member_container_item_four item_big">Employer</div>
                  <div class="member_container_item_four item_big">Expired</div>
                </div>
                <div class="member_container_item_expired" v-for="(item, index) in sps" :key="'sp_' + index">
                  <div class="member_container_item_three item_big">{{ index + 1 }}</div>
                  <div class="member_container_item_four item_big" style="text-align: left">{{ item.user_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.contractor_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.permit_enddate }}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Employment Pass(EP)">
              <div class="expired_content_workforce">
                <div class="member_container_item_expired">
                  <div class="member_container_item_three item_big">S/N</div>
                  <div class="member_container_item_four item_big">Name</div>
                  <div class="member_container_item_four item_big">Employer</div>
                  <div class="member_container_item_four item_big">Expired</div>
                </div>
                <div class="member_container_item_expired" v-for="(item, index) in eps"
                     :key="'ep_' + index">
                  <div class="member_container_item_three item_big">{{ index + 1 }}</div>
                  <div class="member_container_item_four item_big" style="text-align: left">{{ item.user_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.contractor_name }}</div>
                  <div class="member_container_item_four item_big">{{ item.permit_enddate }}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import memberinfo from '@/components/manpower/memberinfo'
import nationality from '@/components/manpower/nationality'
import stafforworker from '@/components/manpower/stafforworker'
import member from '@/components/manpower/member'
import expired from "@/components/manpower/expired";
import axios from 'axios'
import echarts from "echarts";

export default {
  name: "workforce",
  props: ['project_id'],

  data() {
    return {
      user_id: '',
      color: this.$store.state.color.chart_color,
      loading: true,
      worker_count: 0,
      staff_count: 0,
      worker_legends: [],
      staff_legends: [],
      worker_values: [],
      staff_values: [],
      showflag: false,
      showflag1: false,
      showflag2: false,
      showLoading1: true,
      showLoading2: true,
      myChart: null,
      myChart1: null,
      myChart2: null,
      expired_title: 'Work Pass',
      dataNotNull: true,
      default_tag: "Expired",
      multi_tags: [
        {label: "3-month Expiry", value: "1"},
        {label: "Expired", value: "0"},
      ],
      default_company: "",
      company_index: 0,
      multi_companies: [],
      members: [],
      work_permit_data: [
        {name: 'Tan Chia Liang', employer: '总包', expired: '01 May 2020'},
        {name: 'Tan Chia Liang', employer: '分包1', expired: '01 May 2020'},
        {name: 'Tan Chia Liang', employer: '分包2', expired: '01 May 2020'},
        {name: 'Tan Chia Liang', employer: '分包3', expired: '01 May 2020'},
        {name: 'Tan Chia Liang', employer: '分包4', expired: '01 May 2020'}
      ],
      name: 'Tan Chia Liang',
      avatar: '../../stdashboard/static/img/user_avatar.png',
      nationality: 'Indian',
      designation: 'General Worker',
      pass_type: 'Work Permit',
      ra_role: 'No',
      tbm_role: 'Conducting',
      ptw_role: 'Applicant',
      certs: [
        'Construction Safety Orientation Course(CSOC)',
        'Managing WAH Course'
      ],

      eps: [],
      sps: [],
      wps: [],
      expired_legends: ['EP', 'SP', 'WP'],
      expired_dates: [],

      member_user_id: '',
    }
  },

  watch: {
    user_id(val) {
    }
  },
  components: {
    memberinfo,
    member,
    stafforworker,
    nationality,
    expired
  },

  methods: {
    showDetail() {
      var that = this
      this.showflag = true
      this.$nextTick(() => {
        if (!this.myChart1) {
          this.myChart1 = echarts.init(document.querySelector('.workforceDiv1 .container1'))
          this.myChart1.setOption({
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)",
              textStyle: {
                fontSize: 24
              }
            },
            legend: {
              orient: 'vertical',
              x: 'right',
              left: '53%',
              top: 'center',
              type: 'scroll',
              itemGap: 12,
              itemHeight: '16',
              itemWidth: 60,
              textStyle: {
                color: '#666',
                fontSize: '18'
              },
              data: that.worker_legends
            },
            series: [{
              name: 'Workers',
              data: that.worker_values,
              type: 'pie',
              hoverOffset: 5,
              radius: ['55%', '80%'],
              center: ['25%', '50%'],
              label: {
                normal: {
                  show: true,
                  position: 'inside',
                  formatter: '{c}',
                  textStyle: {
                    fontSize: '20',
                  }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '24',
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },

              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.color[params.dataIndex % 10]
                  }
                },
                //鼠标悬停时：
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  borderWidth: 1
                }
              }
            }],
          })

          // this.myChart1.showLoading({
          //   text: '',
          //   color: '#66CCFF',
          //   maskColor: 'rgba(255, 255, 255, 0)',
          // });
        }
        if (!this.myChart2) {
          this.myChart2 = echarts.init(document.querySelector('.workforceDiv1 .container2'))
          this.myChart2.setOption({
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b}: {c} ({d}%)",
              textStyle: {
                fontSize: 24
              }
            },
            legend: {
              orient: 'vertical',
              x: 'right',
              left: '53%',
              top: 'center',
              type: 'scroll',
              itemGap: 12,
              itemHeight: '16',
              itemWidth: 60,
              textStyle: {
                color: '#666',
                fontSize: '18'
              },
              data: that.staff_legends
            },
            series: [{
              name: 'Staff',
              data: that.staff_values,
              type: 'pie',
              hoverOffset: 5,
              radius: ['55%', '80%'],
              center: ['25%', '50%'],
              label: {
                normal: {
                  show: true,
                  position: 'inside',
                  formatter: '{c}',
                  textStyle: {
                    fontSize: '20',
                  }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '24',
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },

              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.color[params.dataIndex % 10]
                  }
                },
                //鼠标悬停时：
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  borderWidth: 1
                }
              }
            }],
          })

          // this.myChart2.showLoading({
          //   text: '',
          //   color: '#66CCFF',
          //   maskColor: 'rgba(255, 255, 255, 0)',
          // });
        }

      })
    },
    showMember(member) {
      this.member_user_id = member.user_id
      this.showflag2 = true
      this.getMemberDetail(member.user_id)
    },

    getMemberDetail(member_user_id) {
      var that = this
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        member_user_id: member_user_id
      }
      axios.post(this.$store.getters.getCmsServer + "DBMemberDetail", postData).then(resp => {    //生产
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          var result = resp.data.result[0];
          that.name = result.user_name.toUpperCase()
          var face = result.face_img.split('opt/www-nginx/web/')
          that.avatar = that.$store.getters.getServer241Address + 'getfile/' + face[face.length - 1]
          that.nationality = result.nation_type
          that.designation = result.role_name_en
          that.pass_type = result.certificate_name_en ? result.certificate_name_en : '--'
          that.ra_role = (function () {
            var role = 'No'
            switch (result.ra_role) {
              case '1':
                role = 'Approver'
                break
              case '2':
                role = 'Leader'
                break
              case '3':
                role = 'Member'
                break
              default:
                role = 'No'
            }
            return role
          })()
          that.tbm_role = (function () {
            var role = 'No'
            switch (result.meeting_flag) {
              case '1':
                role = 'Applicant'
                break
              case '2':
                role = 'Assessor'
                break
              case '3':
                role = 'Approver'
                break
              default:
                role = 'No'
            }
            return role
          })()
          that.ptw_role = (function () {
            var role = 'No'
            switch (result.ptw_role) {
              case '1':
                role = 'Applicant'
                break
              case '2':
                role = 'Assessor'
                break
              case '3':
                role = 'Approver'
                break
              default:
                role = 'No'
            }
            return role
          })()
          var certs = result.certs
          if (certs && certs.length > 0) {
            that.certs = result.certs.split(',')
          } else {
            that.certs = []
          }
        } else {
        }
      }).catch(error => {
        alert(error)
      })
    },
    detailClose() {
      this.showflag = false
    },
    detail1Close() {
      this.showflag1 = false
    },
    detail2Close() {
      this.showflag2 = false
    },
    switch_tag(label) {
      this.getExpired(label)
    },
    switch_company(label) {
      this.company_index = label
    },
    analysisResult(result) {
      var legends = []
      var series = []
      for (var i in result) {
        legends.push(result[i].nation_type)
        series.push({name: result[i].nation_type, value: result[i].nation_num})
      }
      return {legends: legends, series: series}
    },
    showExpired() {
      var that = this
      that.showflag1 = true
    },
    getExpired(label) {
      let that = this
      if (!that.myChart) {
        this.myChart = echarts.init(document.querySelector('.expiredDiv .container1'))
        this.myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            textStyle: {
              fontSize: '16'
            }
          },
          xAxis: {
            type: 'category',
            inverse: true,
            data: that.expired_legends,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#6CF'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#FFF',
                fontSize: 16
              }
            },
            splitLine: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            // axisLabel: {
            //   formatter: '{value}'
            // },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              type: 'bar',
              barWidth: '40%',
              data: [],
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.color[params.dataIndex]
                  },
                }
              },
            }
          ]
        })

        this.myChart.on('click', function (param) {
          that.showExpired()
        });
      }
      this.myChart.showLoading({
        text: '',
        color: '#66CCFF',
        maskColor: 'rgba(255, 255, 255, 0)',
      });

      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
        nowdate: that.getNowDate()
      }
      if (label == 1) {
        postData.enddate = that.getEndDate()
      }
      axios.post(this.$store.getters.getCmsServer + "DBWorkPassExpired", postData).then(resp => {    //生产
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          var result = resp.data.result;
          that.eps = []
          that.sps = []
          that.wps = []
          that.expired_dates = []
          var ep_count = 0
          var sp_count = 0
          var wp_count = 0
          result.forEach((item) => {
            if (item.certificate_type == '36') {
              wp_count += 1
              that.wps.push(item)
            }
            if (item.certificate_type == '37') {
              sp_count += 1
              that.sps.push(item)
            }
            if (item.certificate_type == '38') {
              ep_count += 1
              that.eps.push(item)
            }
          })
          that.expired_dates = [ep_count, sp_count, wp_count]
          if (this.dataNotNull) {
            this.myChart.setOption({
              legend: {
                data: that.expired_legends,
                itemGap: 6,
              },
              series: [{
                data: that.expired_dates
              }]
            })
          }
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    getMembers() {
      var that = this
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token'),
      }
      axios.post(this.$store.getters.getCmsServer + "DBMember", postData).then(resp => {    //生产
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          var result = resp.data.result
          that.multi_companies = []
          // that.members = result
          var con_ids = []
          result.forEach((item) => {
            var index = con_ids.indexOf(item.contractor_id)
            if (index < 0) {
              con_ids.push(item.contractor_id)
              var length = that.multi_companies.length
              that.multi_companies.push({
                label: item.contractor_short_name,
                value: length
              })
              that.members.push([item])
            } else {
              that.members[index].push(item)
            }
          })
          that.company_index = 0
          if (result.length > 0) {
            that.default_company = that.multi_companies[0].label
          }
        } else {
        }
      }).catch(error => {
        alert(error)
      })
    },
    getNowDate() {
      var nowDate = new Date()
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
      var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "-" + month + "-" + day;
      return dateStr
    },
    getEndDate() {
      var nowDate = new Date()
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 4
      if (month > 12) {
        month -= 12
        year += 1
      }
      month = month < 10 ? "0" + month : month
      var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "-" + month + "-" + day;
      return dateStr
    }
  },

  mounted() {
    var that = this
    let postData = {
      project_id: this.project_id,
      type: '1',
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(that.$store.getters.getCmsServer + "DBProjStaff", postData).then(resp => {    //生产
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      if (errNo == "0") {
        var staff = resp.data.result;
        that.staff_count = 0
        that.staff_legends = []
        that.staff_values = []
        staff.forEach((item) => {
          that.staff_count += parseInt(item.count)
          that.staff_legends.push(item.role_type)
          that.staff_values.push({
            name: item.role_type,
            value: item.count
          })
        })
        postData.type = '0'
        axios.post(that.$store.getters.getCmsServer + "DBProjStaff", postData).then(resp => {    //生产
          that.loading = false
          var errNo = resp.data.errno
          var errStr = resp.data.errstr_cn
          if (errNo == "0") {
            var worker = resp.data.result;
            that.worker_count = 0
            that.worker_legends = []
            that.worker_values = []
            worker.forEach((item) => {
              that.worker_count += parseInt(item.count)
              that.worker_legends.push(item.role_type)
              that.worker_values.push({
                name: item.role_type,
                value: item.count
              })
            })
          } else {
            alert(errStr)
          }
        }).catch(error => {
          that.loading = false
          alert(error)
        })
      } else {
        that.loading = false
        alert(errStr)
      }
    }).catch(error => {
      that.loading = false
      alert(error)
    })
    that.getExpired(0)
    that.getMembers()
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
    if (this.myChart2) {
      this.myChart2.clear()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

.workforce-container {
  margin: 0;
  padding: 0;
  color: #FFF
  position: relative;
  width: 100%
  height: 100%
  overflow: hidden
  display flex
}

.workforce-container-left {
  width 50%
  height 100%
  /*background-color #7e8bad*/
  display flex
  flex-direction column
}

.work_expired_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 60%;
  height: 80%;
  left: 20%;
  top: 8%;
  text-align: left;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.has-border {
  width 97%
  height 97%
  overflow scroll
  margin 1%
  border 1px solid #333
  display flex
  flex-direction column
}

.member_title {
  width 90%
  height 30px
  line-height 30px
  font-size 16px
  margin-left 16px
  color white
  text-align left
}

.member_project .el-input__inner {
  font-size 16px
  color #66CCFF
  width: 300px;
  height: 40px;
  line-height 40px;
  background-color transparent
  border none
}

.el-select .el-input .el-select__caret {
  display none
}

.member_container_item_expired {
  width 100%
  height 40px
  margin-top 5px
  display flex
  text-align center
}

.member_container_item_one_workforce {
  width 10%;
  height 30px
  line-height 30px
  font-size 14px
}

.member_container_item_one_workforce_special {
  width 10%;
  //height 30px
  line-height 22px
  font-size 14px
}

.member_container_item_two_workforce {
  width 45%;
  height 30px
  line-height 30px
  font-size 14px
}

.member_container_item_two_workforce_special {
  width 45%;
  //height 30px
  line-height 22px
  font-size 14px
  word-break: break-all
}

.member_container_item_three {
  width 15%;
  height 30px
  line-height 30px
  font-size 14px
}

.member_container_item_four {
  width 28%;
  height 30px
  line-height 30px
  font-size 14px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.member_container_item_container {
  width: 100%;
  height: 520px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  overflow: scroll
}

.item_big {
  font-size 18px
  margin-top 20px
}

.workforce-container-left-one {
  width 100%
  height 32%
  display flex
  margin-top: 1%
}

.workforce_item {
  background-color #31334a
  font-size 1em
  text-align: center;
  width 46%
  margin 0 1%
  height 100%
}

.item_outer {
  display flex
  flex-wrap wrap
  font-size 16px
}

.item_outer_title {
  padding-left 10px
  margin-top 10px
  width 100%
  height 30px
  font-size 16px
  line-height 30px
  text-align left
  margin-left 10px
  font-weight bold
}

.item_outer_item {
  width 50%
  height 120px
}

.item_outer_item_count {
  font-size 48px
  width 100%
  height 60px
  line-height 60px
  overflow: hidden;
  /*display: -webkit-box;*/
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.item_outer_item_type {
  font-size 24px
  height 40px
  line-height 40px
}

.member-container {
  position: relative;
  width: 100%
  height: 100%
}

.close_img_workforce {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
  z-index 9
}

.container1, .container2 {
  width 100%
  height 44%
}

.title_expired {
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px
}

.zero_expired {
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
}

.expired .el-input__inner {
  font-size 16px
}

.h_big .el-input__inner {
  font-size 30px
}

.expired_content_workforce {
  width 100%
  max-height 270px
  overflow scroll
  display flex
  flex-direction column
  text-align center
  font-size 26px
}

.close_img_expired {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
}

.company_select .el-input__inner {
  background-color #cccccc
}

.workforce_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 60%;
  height: 90%;
  left: 20%;
  top: 4%;
  text-align: left;
  font-size: 40px;
  z-index: 99;
  color #333333
}

.member_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 40%;
  height: 100%;
  left: 20%;
  top: 0;
  text-align: left;
  font-size: 40px;
  z-index: 99;
  color #333333
}

.member_detail_item_small {
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  width: calc(100% - 40px);
  margin-left 20px
  text-align: left;
  line-height: 30px
}

.member_margin_top {
  margin-top 10px
}

.member_detail_item_certs {
  width calc(100% - 30px)
  height 220px
  overflow scroll
  display flex
  flex-direction column
  border 1px solid red
  margin-left 10px
  margin-top 10px
}

.member_detail_item_cert_title {
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  width: calc(100% - 20px);
  margin-left 10px
  text-align: left;
  line-height: 30px
}

.member_detail_item_cert {
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  width: calc(100% - 30px);
  margin-left 15px
  text-align: left;
  line-height: 30px
}

.workforce_detail_title {
  height 5%
  margin-left 10px
  font-size 18px
  text-align left
  font-weight bold
  color #333
}

.close_img_workforce {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 20px;
  top: 20px;
  width: 20px;
  height: 20px;
  z-index 9
}


</style>



// WEBPACK FOOTER //
// src/components/manpower/workforce.vue